import styled from 'styled-components';
import Button from '~components/Button';
import { media } from '~constants/media';

export const BlueButton = styled(Button)`
  background-color: #6082ff;
  padding: 0px 22px;
  height: 39px;
  color: white;
  font-size: 13px;
  line-height: 15px;

  &:hover,
  &:focus {
    background-color: #819cff;
  }

  ${media.lg`
      height: 46px;
      font-size: 17px;
      line-height: 19px;
    `}
`;
